/* Aza Natural — eigen scripts (thema-scoped) */

/* Hoogte van de vaste kop als CSS-variabele (--aza-kop-hoogte), zodat iets
   dat onder de kop moet plakken (de filterknop op mobiel, upgrade CP-03) daar
   precies onder komt. Zonder script geldt de terugval in de CSS. */
(function () {
  var kop = document.getElementById('site-header');
  if (!kop || !window.ResizeObserver) return;
  var houder = kop.closest('.shopify-section') || kop;
  new ResizeObserver(function () {
    document.documentElement.style.setProperty('--aza-kop-hoogte', houder.offsetHeight + 'px');
  }).observe(houder);
})();

/* Footerkolommen (sections/footer.liquid): in de HTML altijd open, zodat ze
   zonder JavaScript en op desktop gewoon zichtbaar zijn. Onder 768 px maakt dit
   script van elke kolomkop een knop en klapt de lijst in. */
(function () {
  if (!window.matchMedia) return;
  var smal = window.matchMedia('(max-width: 767px)');
  var kolommen = [];
  function zet() {
    kolommen = document.querySelectorAll('[data-aza-foot-col]');
    for (var i = 0; i < kolommen.length; i++) {
      var kop = kolommen[i].querySelector('[data-aza-foot-title]');
      var lijst = kolommen[i].querySelector('[data-aza-foot-list]');
      if (!kop || !lijst) continue;
      var tekst = kop.textContent.trim();
      if (smal.matches) {
        if (kop.querySelector('button')) continue;
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'aza-foot__toggle';
        knop.setAttribute('aria-expanded', 'false');
        knop.setAttribute('aria-controls', lijst.id);
        knop.textContent = tekst;
        knop.addEventListener('click', function () {
          var open = this.getAttribute('aria-expanded') !== 'true';
          this.setAttribute('aria-expanded', String(open));
          document.getElementById(this.getAttribute('aria-controls')).hidden = !open;
        });
        kop.replaceChildren(knop);
        lijst.hidden = true;
      } else {
        var span = document.createElement('span');
        span.textContent = tekst;
        kop.replaceChildren(span);
        lijst.hidden = false;
      }
    }
  }
  zet();
  if (smal.addEventListener) smal.addEventListener('change', zet);
  // In de thema-editor vervangt Shopify de footer na elke wijziging.
  document.addEventListener('shopify:section:load', zet);
})();

/* De gratis-verzendbalk tekent zichzelf in assets/component-shipping-notice.js
   (upgrade WA-03). Hier stond een ombouwscript met een MutationObserver op de
   hele pagina. */

/* Beeldvangnet voor .lazy-image.

   Het thema verbergt elk beeld in een .lazy-image (opacity: 0) tot de klasse
   .lazyloaded op de houder staat, en die klasse kwam alleen van een inline
   onload-handler in de HTML. Zodra die handler niet loopt - geblokkeerd,
   overgeslagen of een beeld dat al klaar was - blijft het beeld voorgoed
   onzichtbaar, ook al is het bestand er wel. Dat is precies wat een pagina
   vol lege kaders oplevert.

   Hier zetten we de klasse zelf: meteen als het beeld al klaar is, anders
   zodra het laadt. Een beeld dat niet kan laden krijgt is-error, zodat er een
   rustig vlak staat in plaats van een leeg gat met een gebroken-beeld-icoon. */
(function () {
  function settle(img) {
    var holder = img.closest ? img.closest('.lazy-image') : null;
    if (!holder) return;
    if (img.naturalWidth > 0) {
      holder.classList.add('lazyloaded');
    } else {
      holder.classList.add('is-error');
    }
  }

  function watch(img) {
    if (img.getAttribute('data-aza-img-watch')) return;
    img.setAttribute('data-aza-img-watch', '1');

    if (img.complete) {
      settle(img);
      return;
    }
    img.addEventListener('load', function () { settle(img); });
    img.addEventListener('error', function () {
      var holder = img.closest ? img.closest('.lazy-image') : null;
      if (holder) holder.classList.add('is-error');
    });
  }

  function sweep(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var images = scope.querySelectorAll('.lazy-image img');
    for (var i = 0; i < images.length; i++) watch(images[i]);
  }

  function start() {
    sweep(document);

    // Nieuwe beelden (sliders, snelle weergave, bijgeladen secties) meteen volgen.
    if (!window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function (mutations) {
      if (pending) return;
      var relevant = false;
      for (var i = 0; i < mutations.length && !relevant; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) relevant = true;
      }
      if (!relevant) return;
      pending = true;
      setTimeout(function () { pending = false; sweep(document); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Laatste ronde: de meeste beelden zijn dan binnen, ook uit de cache.
  window.addEventListener('load', function () { setTimeout(function () { sweep(document); }, 200); });
})();

/* Inschrijfformulieren versturen zonder de pagina te verlaten.
   Een nieuwsbrief- of kortingsformulier deed tot nu toe een gewone POST naar
   /contact. Daardoor verliet de bezoeker de pagina waar hij iets wilde kopen.
   Erger nog: als de spambeveiliging van Shopify geen token meekrijgt, antwoordt
   die met HTTP 400 en maakt de browser daar zijn eigen foutpagina van, zonder
   enige huisstijl. Dat is de pagina die bezoekers te zien kregen.
   De POST gaat nu naar een verborgen iframe, zodat het hoofdvenster blijft staan
   waar het stond. Het blijft een echte formulierinzending, dus de captcha van
   Shopify blijft gewoon werken.
   Wat dit bewust niet doet: het resultaat van de inzending lezen. Deze winkel
   stuurt frame-ancestors 'none' mee, dus de browser weigert elke eigen pagina in
   een iframe te tonen. Een goed- of afkeurmelding zou dus gokken zijn. In plaats
   daarvan tonen we de tekst uit #aza-inschrijving-gelukt (zie
   layout/theme.liquid), en die is zo geschreven dat hij klopt of de inzending nu
   wel of niet is aangekomen.
   Werkt het script niet, dan doet het formulier gewoon wat het altijd deed. */
(function () {
  var FRAME_NAAM = 'aza-formulier-frame';
  var frame = null;
  var bezig = null;
  var timer = null;
  var frameIsNieuw = true;

  function maakFrame() {
    if (frame) return frame;
    frame = document.createElement('iframe');
    frame.name = FRAME_NAAM;
    frame.setAttribute('title', 'Verwerking van het formulier');
    frame.setAttribute('aria-hidden', 'true');
    frame.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;border:0';
    frame.addEventListener('load', naLaden);
    document.body.appendChild(frame);
    return frame;
  }

  function isInschrijfformulier(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    var veld = form.querySelector('input[name="form_type"]');
    return !!veld && veld.value === 'customer';
  }

  function bevestigingstekst() {
    var bron = document.getElementById('aza-inschrijving-gelukt');
    return bron ? bron.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function toonBevestiging(form) {
    var tekst = bevestigingstekst();
    if (!tekst || !form.parentNode) return;
    var p = document.createElement('p');
    p.className = 'aza-inschrijving-gelukt';
    p.setAttribute('role', 'status');
    p.textContent = tekst;
    form.parentNode.replaceChild(p, form);
  }

  function herstel(form) {
    if (!form || !form.parentNode) return;
    var knop = form.querySelector('[type="submit"]');
    if (knop) knop.removeAttribute('aria-busy');
  }

  function naLaden() {
    if (frameIsNieuw) { frameIsNieuw = false; return; }
    if (!bezig) return;
    var form = bezig;
    bezig = null;
    clearTimeout(timer);
    toonBevestiging(form);
  }

  /* In de capture-fase, dus voor de captcha van Shopify de inzending overneemt.
     Het doel van het formulier staat dan al op het iframe. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isInschrijfformulier(form)) return;
    maakFrame();
    form.setAttribute('target', FRAME_NAAM);
    bezig = form;
    var knop = form.querySelector('[type="submit"]');
    if (knop) knop.setAttribute('aria-busy', 'true');
    clearTimeout(timer);
    /* Alleen om de knop weer vrij te geven als er nooit iets terugkomt. Geen
       melding, want we weten niet wat er aan de hand is. */
    timer = setTimeout(function () { if (bezig) { herstel(bezig); bezig = null; } }, 30000);
  }, true);

  function zetDoelOpAlleFormulieren() {
    var velden = document.querySelectorAll('form input[name="form_type"][value="customer"]');
    if (!velden.length) return;
    maakFrame();
    for (var i = 0; i < velden.length; i++) {
      var form = velden[i].form;
      if (form && !form.getAttribute('target')) form.setAttribute('target', FRAME_NAAM);
    }
  }

  if (document.readyState !== 'loading') { zetDoelOpAlleFormulieren(); }
  else { document.addEventListener('DOMContentLoaded', zetDoelOpAlleFormulieren); }
})();

/* Sitewide DIY-ingang. Op de homepage scrollt hij soepel naar het Lab en
   verdwijnt hij zodra het Lab zelf in beeld staat. Op andere pagina's blijft
   het een gewone link naar de homepage-anchor. Onderaan de footer gaat hij
   ook weg, anders ligt hij over de betaalmethoden en de juridische links. */
(function () {
  function initDiySticky() {
    var trigger = document.querySelector('[data-aza-diy-sticky]');
    if (!trigger) return;
    var labInBeeld = false;
    var voetInBeeld = false;
    function zet() { trigger.classList.toggle('is-hidden', labInBeeld || voetInBeeld); }

    var voet = document.querySelector('.aza-foot__bottom');
    if (voet && window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        voetInBeeld = entries[entries.length - 1].isIntersecting;
        zet();
      }).observe(voet);
    }

    var lab = document.getElementById('aza-diy-inspiration');
    if (!lab) return;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      lab.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    });

    if (!window.IntersectionObserver) return;
    new IntersectionObserver(function (entries) {
      labInBeeld = entries[entries.length - 1].isIntersecting;
      zet();
    }, { rootMargin: '-10% 0px -10% 0px', threshold: 0.08 }).observe(lab);
  }

  if (document.readyState !== 'loading') initDiySticky();
  else document.addEventListener('DOMContentLoaded', initDiySticky);
})();

/* App-widgets toegankelijk en crawlbaar (ronde 49). Judge.me, Fly en
   Greenspark zetten markup in de pagina die Lighthouse (SEO en
   toegankelijkheid) en axe afkeuren, en die ook voor bezoekers niet klopt:
   - Judge.me 'Klanten geven ons ...': een <a href="javascript:void(0)"> die
     bij een klik niets doet. Wordt een echte link naar /pages/reviews.
   - Judge.me zwevende tab: de link 'Gebaseerd op .. beoordelingen' verliest
     zijn href als Judge.me de tab opbouwt; weer naar /pages/reviews.
   - Judge.me-medailles: <a> zonder bestemming; het zijn plaatjes (role=img,
     de aria-label hebben ze al).
   - Fly 'Frequently bought': productfoto's zonder alt. De productnaam staat
     er als tekst naast, dus alt="" (geen dubbele voorleestekst).
   - Greenspark: logo-<a> zonder href en zonder klikactie; een plaatje.
   Alleen ontbrekende attributen worden gezet, dus dit loopt nooit in een
   kring met de MutationObserver. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reviews = root + 'pages/reviews';

  function zet(lijst, naam, waarde) {
    for (var i = 0; i < lijst.length; i++) lijst[i].setAttribute(naam, waarde);
  }

  function herstel() {
    zet(document.querySelectorAll('.jdgm-all-reviews-text a[href^="javascript"], a.jdgm-revs-tab__url:not([href])'), 'href', reviews);
    zet(document.querySelectorAll('a.jdgm-medal:not([href]):not([role])'), 'role', 'img');
    zet(document.querySelectorAll('img.gfbFrequentBoughtWidgetProductImageEle:not([alt])'), 'alt', '');
    var gs = document.querySelectorAll('a.gs-logo-website-cta:not([href]):not([role])');
    zet(gs, 'role', 'img');
    zet(gs, 'aria-label', 'Greenspark');
  }

  function start() {
    herstel();
    if (!window.MutationObserver) return;
    var wacht = false;
    new MutationObserver(function () {
      if (wacht) return;
      wacht = true;
      setTimeout(function () { wacht = false; herstel(); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* Reviewkaartjes linksonder (snippets/aza-review-popup.liquid), vervangen de
   Judge.me-popup (ronde 49). Pas na de eerste interactie en dan 6 s, één
   kaartje tegelijk, 8 s zichtbaar, 12 s pauze, hoogstens drie per bezoek.
   Met de muis erop blijft het staan; wegklikken geldt voor de rest van het
   bezoek. Alleen vanaf 768 px: op mobiel lag de Judge.me-popup over de
   winkelmand. Nooit over de vaste koopbalk of de DIY-knop, en niet zolang het
   DIY Lab in beeld is: het kaartje viel daar over de knop 'Verder', en een
   klik ging dan naar de reviewpagina (ronde 50). */
(function () {
  var bron = document.getElementById('aza-review-popup');
  if (!bron || !bron.content || !window.matchMedia('(min-width: 768px)').matches) return;
  try { if (sessionStorage.getItem('aza-review-popup') === 'dicht') return; } catch (e) { /* geen opslag: gewoon tonen */ }
  var kaarten = bron.content.querySelectorAll('[data-aza-review-kaart]');
  if (!kaarten.length) return;
  var max = Math.min(3, kaarten.length);
  var doos, link, timer, getoond = 0;

  function maak() {
    doos = document.createElement('aside');
    doos.className = 'aza-review-popup';
    doos.setAttribute('aria-label', bron.getAttribute('data-label'));
    link = document.createElement('a');
    link.className = 'aza-review-popup__link';
    link.href = bron.getAttribute('data-url');
    var sluit = document.createElement('button');
    sluit.type = 'button';
    sluit.className = 'aza-review-popup__sluit';
    sluit.setAttribute('aria-label', bron.getAttribute('data-sluit'));
    sluit.addEventListener('click', function () {
      clearTimeout(timer);
      doos.remove();
      try { sessionStorage.setItem('aza-review-popup', 'dicht'); } catch (e) { /* niet erg */ }
    });
    doos.addEventListener('mouseenter', function () { clearTimeout(timer); });
    doos.addEventListener('mouseleave', function () { if (doos.classList.contains('is-zichtbaar')) timer = setTimeout(verberg, 4000); });
    doos.appendChild(link);
    doos.appendChild(sluit);
    document.body.appendChild(doos);
  }

  // Niet over de vaste koopbalk (productpagina, schuift in en uit beeld, dus
  // altijd ruimte houden) en niet over de DIY-knop onderin het midden.
  function plaats() {
    var ruimte = 0;
    var koopbalk = document.querySelector('sticky-add-to-cart');
    if (koopbalk) ruimte = koopbalk.offsetHeight;
    var diy = document.querySelector('[data-aza-diy-sticky]');
    if (diy && !diy.classList.contains('is-hidden')) {
      var r = diy.getBoundingClientRect();
      if (r.height && r.left < doos.offsetWidth + 40) ruimte = Math.max(ruimte, window.innerHeight - r.top);
    }
    doos.style.bottom = (ruimte > 0 ? ruimte + 12 : 24) + 'px';
  }

  var labInBeeld = false;
  var labs = document.querySelectorAll('[data-aza-diy-lab]');
  if (labs.length && window.IntersectionObserver) {
    var zicht = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { zicht.set(entry.target, entry.isIntersecting); });
      labInBeeld = Array.from(zicht.values()).some(Boolean);
      if (labInBeeld && doos && doos.classList.contains('is-zichtbaar')) {
        clearTimeout(timer);
        verberg();
      }
    });
    labs.forEach(function (lab) { io.observe(lab); });
  }

  function toon() {
    if (labInBeeld) { timer = setTimeout(toon, 4000); return; }
    if (!doos) maak();
    plaats();
    link.replaceChildren(kaarten[getoond].cloneNode(true));
    getoond++;
    requestAnimationFrame(function () { doos.classList.add('is-zichtbaar'); });
    timer = setTimeout(verberg, 8000);
  }

  function verberg() {
    doos.classList.remove('is-zichtbaar');
    if (getoond < max) timer = setTimeout(toon, 12000);
  }

  var events = ['pointerdown', 'touchstart', 'keydown', 'mousemove', 'wheel'];
  function start() {
    events.forEach(function (e) { window.removeEventListener(e, start, { passive: true }); });
    timer = setTimeout(toon, 6000);
  }
  events.forEach(function (e) { window.addEventListener(e, start, { passive: true, once: true }); });
})();
